import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdatePrestacionCUMEByID = () => {
  const [loadingUpdatePrestacionCUMEById, setLoadingCreatePrestacionCUME] = useState(false);
  const [successUpdatePrestacionCUMEById, setSuccessCreatePrestacionCUME] = useState(false);
  const [errorUpdatePrestacionCUMEById, setErrorCreatePrestacionCUME] = useState(null);
  const [dataUpdatePrestacionCUMEById, setDataPrestacionCUME] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updatePrestacionCUMEById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionCUME(true);
    setSuccessCreatePrestacionCUME(false);
    setErrorCreatePrestacionCUME(null);

    
    apiRecord.updatePrestacionEconomicaCUMEByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionCUME(false);
        setSuccessCreatePrestacionCUME(true);
        setDataPrestacionCUME(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionCUME(false);
        setErrorCreatePrestacionCUME(err.response?.data);
      });
  };

  return {
    updatePrestacionCUMEById,
    loadingUpdatePrestacionCUMEById,
    successUpdatePrestacionCUMEById,
    errorUpdatePrestacionCUMEById,
    dataUpdatePrestacionCUMEById
  };
};

export default useUpdatePrestacionCUMEByID;
